import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import Default from "./layouts/Default.vue";
import FullWidth from "./layouts/FullWidth.vue";
Vue.component('default-layout', Default);
Vue.component('fullwidth-layout', FullWidth);

import './../node_modules/bulma/css/bulma.css';

// Import the Auth0 configuration
import { domain, clientId, audience } from "../auth_config.json";

// Import the plugin here
import { Auth0Plugin } from "./auth";

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

// Global functions
Vue.mixin({
  methods: {
    async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently()
    },
  },
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
